<div class="blank-container">

  <div class="blank-container-box">

    <p> Logging Out ..</p>

  </div>

</div>
